import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSearch = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.199 4.80618C22.2987 7.90591 22.2987 12.9316 19.199 16.0313C16.2895 18.9408 11.6832 19.1194 8.56547 16.567L3.84828 21.2832C3.53439 21.5971 3.02549 21.5971 2.7116 21.2832C2.39772 20.9694 2.39772 20.4604 2.7116 20.1466L7.42912 15.4286C4.88624 12.311 5.06782 7.71222 7.97387 4.80618C11.0736 1.70644 16.0993 1.70644 19.199 4.80618ZM9.11055 5.94285C6.63858 8.41482 6.63858 12.4227 9.11055 14.8946C11.5825 17.3666 15.5904 17.3666 18.0623 14.8946C20.5343 12.4227 20.5343 8.41482 18.0623 5.94285C15.5904 3.47088 11.5825 3.47088 9.11055 5.94285Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.199 4.80618C22.2987 7.90591 22.2987 12.9316 19.199 16.0313C16.2895 18.9408 11.6832 19.1194 8.56547 16.567L3.84828 21.2832C3.53439 21.5971 3.02549 21.5971 2.7116 21.2832C2.39772 20.9694 2.39772 20.4604 2.7116 20.1466L7.42912 15.4286C4.88624 12.311 5.06782 7.71222 7.97387 4.80618C11.0736 1.70644 16.0993 1.70644 19.199 4.80618ZM9.11055 5.94285C6.63858 8.41482 6.63858 12.4227 9.11055 14.8946C11.5825 17.3666 15.5904 17.3666 18.0623 14.8946C20.5343 12.4227 20.5343 8.41482 18.0623 5.94285C15.5904 3.47088 11.5825 3.47088 9.11055 5.94285Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5357 4.46946C22.8214 7.75516 22.8214 13.0823 19.5357 16.368C16.556 19.3477 11.8979 19.6252 8.60522 17.2006L4.185 21.62C4.18499 21.62 4.18501 21.62 4.185 21.62C3.68515 22.1198 2.87472 22.1198 2.37489 21.62C1.87504 21.1201 1.87504 20.3097 2.37487 19.8099C2.37488 19.8099 2.37487 19.8099 2.37487 19.8099L6.796 15.3883C4.3807 12.0963 4.66095 7.44567 7.63715 4.46946C10.9229 1.18376 16.25 1.18376 19.5357 4.46946ZM7.42912 15.4286L2.7116 20.1466C2.39772 20.4604 2.39772 20.9694 2.7116 21.2832C3.02549 21.5971 3.53439 21.5971 3.84828 21.2832L8.56547 16.567C11.6832 19.1194 16.2895 18.9408 19.199 16.0313C22.2987 12.9316 22.2987 7.90591 19.199 4.80618C16.0993 1.70644 11.0736 1.70644 7.97387 4.80618C5.06782 7.71222 4.88624 12.311 7.42912 15.4286ZM9.44727 6.27957C7.16126 8.56558 7.16126 12.2719 9.44727 14.5579C11.7333 16.8439 15.4396 16.8439 17.7256 14.5579C20.0116 12.2719 20.0116 8.56558 17.7256 6.27957C15.4396 3.99357 11.7333 3.99357 9.44727 6.27957ZM9.11055 14.8946C6.63858 12.4227 6.63858 8.41482 9.11055 5.94285C11.5825 3.47088 15.5904 3.47088 18.0623 5.94285C20.5343 8.41482 20.5343 12.4227 18.0623 14.8946C15.5904 17.3666 11.5825 17.3666 9.11055 14.8946Z", fill: props.fill }));
});
export default SvgSearch;
